<!--  -->
<template>
  <div class="container">
    <img src="../../assets/register/network/network-01.jpg" alt="电信营业许可证">
     <img src="../../assets/register/network/network-02.jpg" alt="电信营业许可证">
      <img src="../../assets/register/network/network-03.jpg" alt="电信营业许可证">
       <img src="../../assets/register/network/network-04.jpg" alt="电信营业许可证">
        <img src="../../assets/register/network/network-05.jpg" alt="电信营业许可证">
         <img src="../../assets/register/network/network-06.jpg" alt="电信营业许可证">
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {}
    },

    props: [],

    watch: {},

    components: {},

    computed: {},

    created() {},

    methods: {}
  }

</script>
<style lang='scss' scoped>
  .container {
    img {}
  }

</style>



// WEBPACK FOOTER //
// src/pages/certificate/certificate.vue